function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "06f1gp3y5b",
  cx: "50.059%",
  cy: "49.956%",
  r: "49.98%",
  fx: "50.059%",
  fy: "49.956%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFB900"
}), React.createElement("stop", {
  offset: "60%",
  stopColor: "#F95D8F"
}), React.createElement("stop", {
  offset: "99.91%",
  stopColor: "#F95353"
})), React.createElement("path", {
  id: "c05pco2eja",
  d: "M7.55 5.804c0 3.054 2.486 5.541 5.54 5.541 3.055 0 5.543-2.487 5.543-5.541 0-3.099-2.444-5.542-5.543-5.542-3.054 0-5.54 2.487-5.54 5.542m7.2 12.436c0 3.055 2.486 5.542 5.54 5.542 3.055 0 5.543-2.487 5.543-5.542 0-3.055-2.444-5.541-5.542-5.541-3.055 0-5.542 2.486-5.542 5.541m-14.4 0c0 3.055 2.487 5.542 5.542 5.542 3.054 0 5.542-2.487 5.542-5.542 0-3.055-2.444-5.541-5.542-5.541-3.055 0-5.542 2.486-5.542 5.541"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  transform: "translate(-40 -7643) translate(-246 7268) translate(286 375)"
}, React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 13,
  fill: "#BFC0C2",
  stroke: "#F9F9F9",
  strokeWidth: 14
}), React.createElement("g", null, React.createElement("g", {
  fill: "#2E3C54"
}, React.createElement("path", {
  d: "M8.553 13.615c-2.837 0-5.15-2.357-5.15-5.28 0-2.924 2.313-5.28 5.15-5.28 2.836 0 5.149 2.356 5.149 5.28 0 2.923-2.313 5.28-5.15 5.28m5.193.698c.088.829.699 1.832 1.833 1.832h.655c.262 0 .48-.218.48-.48V1.222c0-.262-.218-.437-.48-.437h-2.051c-.262 0-.437.175-.48.437V2.4C12.436.873 10.472.218 8.509.218 4.015.218.393 3.84.393 8.335c.043 4.494 3.665 8.116 8.16 8.116 1.963 0 4.102-.742 5.192-2.138M41.76 13.615c-2.837 0-5.15-2.357-5.15-5.28 0-2.924 2.313-5.28 5.15-5.28 2.836 0 5.15 2.356 5.15 5.28 0 2.923-2.314 5.28-5.15 5.28m5.15.698c.086.829.697 1.832 1.832 1.832h.654c.262 0 .48-.218.48-.48V1.222c0-.262-.218-.437-.48-.437H47.39c-.261 0-.436.175-.48.437V2.4C45.643.873 43.68.218 41.716.218 37.222.218 33.6 3.84 33.6 8.335c0 4.494 3.622 8.116 8.116 8.116 2.007 0 4.146-.742 5.193-2.138M78.85 13.615c-2.836 0-5.148-2.357-5.148-5.28 0-2.924 2.312-5.28 5.149-5.28 2.836 0 5.15 2.356 5.15 5.28 0 2.923-2.314 5.28-5.15 5.28m5.192.698c.088.829.699 1.832 1.834 1.832h.654c.262 0 .48-.218.48-.48V1.222c0-.262-.218-.437-.48-.437H84.48c-.262 0-.437.175-.48.437V2.4C82.734.873 80.77.218 78.807.218c-4.494 0-8.116 3.622-8.116 8.117 0 4.494 3.622 8.116 8.116 8.116 2.007 0 4.146-.742 5.236-2.138M68.16 14.793V7.33c0-4.233-2.662-7.07-6.895-7.07-2.007 0-3.883 1.18-4.276 2.183-.13-.786-.524-1.615-1.833-1.615h-.654c-.262 0-.48.218-.48.48v14.487c0 .262.218.437.48.437H56.728s.043 0 .043-.044h.043l.044-.043.044-.044c.044-.087.087-.175.087-.262V7.2c0-2.269 1.833-4.102 4.102-4.102s4.102 1.833 4.102 4.102v8.553c0 .262.218.436.48.436h2.225s.044 0 .044-.043h.044l.043-.044.044-.044c.043-.087.087-.174.087-.262v-1.003zM21.556 12.218c1.353.96 2.837 1.396 4.277 1.396 1.352 0 2.749-.697 2.749-1.92 0-1.658-3.055-1.876-4.975-2.53-1.92-.655-3.578-2.008-3.578-4.19 0-3.36 2.967-4.712 5.76-4.712 1.745 0 3.578.567 4.757 1.396.392.306.174.655.174.655l-1.135 1.614c-.13.175-.348.35-.654.131-.306-.174-1.44-1.004-3.142-1.004s-2.705.786-2.705 1.746c0 1.178 1.309 1.527 2.88 1.92 2.705.742 5.673 1.614 5.673 4.93 0 2.968-2.75 4.758-5.804 4.758-2.313 0-4.277-.655-5.935-1.877-.349-.35-.087-.655-.087-.655l1.134-1.614c.219-.218.48-.131.611-.044",
  transform: "translate(57 9.5) translate(30.982 3.927)"
})), React.createElement("g", {
  transform: "translate(57 9.5)"
}, React.createElement("mask", {
  id: "0seis53toc",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#c05pco2eja"
})), React.createElement("path", {
  fill: "url(#06f1gp3y5b)",
  fillRule: "nonzero",
  d: "M13.265.13C20.99.13 27.23 6.37 27.23 14.096c0 7.723-6.24 13.963-13.964 13.963-7.723 0-13.963-6.24-13.963-13.963C-.655 6.37 5.585.13 13.265.13z",
  mask: "url(#0seis53toc)"
})))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 176,
    height: 40,
    viewBox: "0 0 176 40"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/integration-asana.405c1587.svg";
export { SvgComponent as ReactComponent };